import React from 'react';

import { NotFoundScreen } from '../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function NotFound() {
  return <NotFoundScreen />;
}
